import { useEffect, useState } from 'react';
import { tutorialsAPI } from '../utils/api';

const VISITOR_KEY = 'realty237.visitor-id';
let cache = null;

const fetchTutorials = () => {
  if (!cache) {
    cache = tutorialsAPI.list().then((r) => r.data.items || []).catch(() => {
      cache = null;
      return [];
    });
  }
  return cache;
};

const visitorId = () => {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
};

export const trackTutorial = (id, type) => {
  tutorialsAPI.track(id, { type, visitor_id: visitorId() }).catch(() => {});
};

// Published tutorials (with a video), fetched once per page load.
export const useTutorials = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchTutorials().then((list) => alive && setItems(list));
    return () => { alive = false; };
  }, []);
  return items;
};

export default useTutorials;
